import React, {Fragment, FunctionComponent, useEffect, useState} from 'react'
import {Dialog, Transition} from "@headlessui/react"
import {XIcon} from "@heroicons/react/outline"

type ModalProps = {
    title: string,
    showButton?: boolean,
    buttonText?: string
    width?: string,
    children?: JSX.Element | JSX.Element[],
    open?: boolean
    onClose?: () => void
    onClick?: () => void
}

export const Modal: FunctionComponent<ModalProps> = (props: ModalProps) => {

    Modal.defaultProps = {
        showButton: true
    };

    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
        }
    }, [props.open])

    const onClose = () => {
        setOpen(false)
        if (props.onClose) {
            props.onClose()
        }
    }

    const onClick = () => {
        setOpen(false)
        if (props.onClick) {
            props.onClick()
        }
    }

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div"
                    className="fixed z-20 inset-0 overflow-y-auto text-base font-sans text-neutral-700"
                    onClose={onClose}>
                <div
                    className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay
                            className="fixed inset-0 bg-black-500 bg-opacity-75 transition-opacity"/>
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            className={`relative top-1/2 max-h-[85vh] md:max-h-full overflow-auto inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-${props.width ?? 'lg'} w-full sm:p-6`}>
                            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                                <button
                                    type="button"
                                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    onClick={onClose}
                                >
                                    <span className="sr-only">Close</span>
                                    <XIcon className="h-6 w-6" aria-hidden="true"/>
                                </button>
                            </div>
                            <div className="sm:flex sm:items-start">
                                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                                    <Dialog.Title as="h3" className="text-2xl mb-6">
                                        {props.title}
                                    </Dialog.Title>
                                    {props.children}
                                </div>
                            </div>
                            {props.showButton && (
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className={`bg-primary w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline focus:outline-none`}
                                        //className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                        onClick={onClick}
                                    >
                                        {props.buttonText || 'Zurück'}
                                    </button>
                                </div>
                            )}
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
